import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  TIKTOK_UTM_SOURCE,
  tiktokPixelService,
} from '~/shared/services/tiktokPixelService'
import { selectTiktokPixelId } from '~/shared/store/common/selects'
import { sendUserTTCLID } from '~/shared/store/user/actions'
import {
  selectUserCountryCode,
  selectUserEmail,
  selectUserUUID,
  selectUserUtmTags,
} from '~/shared/store/user/selects'

const TTCLID_QUERY_PARAM = 'ttclid'

export const useTiktokPixelInitialization = (): void => {
  const dispatch = useDispatch()
  const tiktokPixelId = useSelector(selectTiktokPixelId)
  const email = useSelector(selectUserEmail)
  const userCountryCode = useSelector(selectUserCountryCode)
  const uuid = useSelector(selectUserUUID)
  const utmTags = useSelector(selectUserUtmTags)

  const isTiktokTraffic = utmTags.utm_source === TIKTOK_UTM_SOURCE

  useEffect(() => {
    if (!tiktokPixelId || !userCountryCode || !uuid) return

    const searchParams = new URLSearchParams(document.location.search)
    const ttclid = searchParams.get(TTCLID_QUERY_PARAM)

    if (ttclid) dispatch(sendUserTTCLID(ttclid))
  }, [dispatch, tiktokPixelId, userCountryCode, uuid])

  useEffect(() => {
    if (!uuid) return

    tiktokPixelService.setUser({ email, externalId: uuid })
  }, [email, uuid])

  useEffect(() => {
    if (!tiktokPixelId || !userCountryCode || !uuid || !isTiktokTraffic) {
      return
    }

    tiktokPixelService.load({ pixelId: tiktokPixelId, eventId: uuid })
  }, [isTiktokTraffic, tiktokPixelId, userCountryCode, uuid])
}
